import { isStreamIQ, isToya } from '@/shared/lib'

export const getVODExternalLinkHandlerHook = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/VOD/lib/useHandleExternalLinkToya')
            return module.useExternalLinkHandlerToya
        } catch (error) {
            console.warn(
                'useExternalLinkHandlerSteamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/features/VOD/hooks/useExternalLinkHandlerSteamIQ')
            return module.useExternalLinkHandlerStreamIQ
        } catch (error) {
            console.warn(
                'useExternalLinkHandlerSteamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
